<script lang="ts" setup>
const auth = useAuth()
const rfqDetails = useRFQDetails()
const route = useRoute()
const isFullBleedPage = computed(() => route.meta.rfqV2FullBleed === true)

useHead({
  title: 'Engage with New Market Makers',
})

// Only fetch when there is a resolvable project (authenticated). Pre-login has
// no project, so the nav renders with the store's default states (see useRfqV2Nav).
if (auth.project) {
  await rfqDetails.fetch()
}
</script>

<template>
  <NuxtLayout name="dashboard" container-layout="fluid" :page-header="{ description: 'Free Tools', title: 'Engage with New Market Makers', icon: '/icons/engage-with-new-market-makers.svg' }">
    <!-- Empty sidebar slot keeps the app menu rail collapsed (core-dashboard only
         expands it on wide screens when no sidebar slot is present). -->
    <template #sidebar>
      <div class="w-0 overflow-hidden" aria-hidden="true" />
    </template>

    <template #header>
      <div class="flex items-center gap-2">
        <img
          src="/icons/engage-with-new-market-makers.svg"
          alt="Engage with New Market Makers"
          class="h-8"
        >
        <div class="shrink-0 text-sm font-semibold">
          Engage with New Market Makers
        </div>
      </div>
    </template>

    <template #app-footer>
      <RfqV2MarketingFooter />
    </template>

    <div class="flex min-h-0 flex-1 flex-col overflow-x-clip">
      <RfqV2TabsNav />
      <div :class="isFullBleedPage ? 'min-h-0 w-full' : 'mx-auto w-full max-w-7xl px-4 py-6 md:p-10'">
        <slot />
      </div>
    </div>
  </NuxtLayout>
</template>
